import { UsersService } from '@shared/services/users/users.service';
import { UserRolesEnum } from '@collections/users/enums/user-roles.enums';
// angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { ErrorService } from 'app/error-handler/services/error.service';
import { NotAuthorizedError } from 'app/error-handler/custom-errors/not-authorized-error';

@Injectable()
export class RoleGuard  {
    constructor(
      private usersService: UsersService,
      private readonly router: Router,
      private errorService: ErrorService
      )
    {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      // this will be passed from the route config
      // on the data property
      return this.handleAuth(route.data.roles);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      return this.canActivate(route, state);
    }

    canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree {
      const isAuth = this.handleAuth(route.data.roles);
      if (!isAuth) {
        this.errorService.handleError(new NotAuthorizedError(route.path));
      }
      return isAuth;
    }

    private handleAuth(roles: UserRolesEnum[], companyId?: string): boolean {
      return this.usersService.isInRole(roles);
    }
}
